import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { PhWarning } from 'ember-phosphor-icons';

export interface HeldParticipantWarningSignature {
  Element: HTMLDivElement;
}

const HeldParticipantWarning: TOC<HeldParticipantWarningSignature> = <template>
  <div class="tio-flex-center items-start" ...attributes>
    <PhWarning @size="24" @weight="fill" class="tio-fg-danger mr-2 shrink-0 relative top-1" />
    <p class="tio-fg-danger font-medium">
      {{t "tuition_assistance.program_details.courses.held_participant_warning"}}
    </p>
  </div>
</template>;

export default HeldParticipantWarning;
